import { useQuery } from '@tanstack/react-query'
import {
  fetchApplicantPayments,
  UseApplicantPaymentsParams,
} from '@/app/apis/Applicants/requests'
import { type PaginatedApplicantPaymentResponse } from '@/app/apis/Applicants/schema'
import { type RequestError } from '@/common/types_and_interfaces'

export const useGetApplicantPayments = ({
  page = 1,
  perPage = 10,
  globalOnId = 1,
  search = '',
  programId = 0,
  applicantId = 0,
  sortBy,
  sortOrder,
  startDate,
  endDate,
}: UseApplicantPaymentsParams = {}) => {
  return useQuery<PaginatedApplicantPaymentResponse, RequestError>({
    queryKey: [
      'applicantPayments',
      {
        page,
        perPage,
        search,
        programId,
        applicantId,
        sortBy,
        sortOrder,
        startDate,
        endDate,
      },
    ],
    queryFn: () =>
      fetchApplicantPayments(
        startDate
          ? {
              page,
              perPage,
              globalOnId,
              search,
              programId,
              applicantId,
              sortBy,
              sortOrder,
              startDate,
              endDate,
            }
          : {
              page,
              perPage,
              globalOnId,
              search,
              programId,
              applicantId,
              sortBy,
              sortOrder,
            }
      ),
    refetchOnMount: 'always',
  })
}
